import { inject } from '@angular/core';
import { PermissionService } from '../services/permission/permission.service';
import { AuthService } from '../services/auth/auth.service';
import { PermissionEnum, ResourceEnum } from '../../../environments/shared-environment/permission';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

export const isAuthenticated = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isLoggedIn())
    return router.navigate([environment.configs.unauthenticatedRoute], { replaceUrl: true }).then(() => false);

  return true;
}

export const notAuthenticated = () => {
  const authService = inject(AuthService);

  if (!authService.isLoggedIn())
    return true

  return false;
}

export const canLogin = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isLoggedIn())
    return router.navigate([environment.configs.authenticatedRoute], { replaceUrl: true }).then(() => false);

  return true;
};

export const canActivateUser = () => {
  const permissionService = inject(PermissionService);
  return permissionService.has(ResourceEnum.USERS, PermissionEnum.VIEW);
};
